import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import getLowestOrganizedUnits from '../../services/organizedUnit/getOrganizedUnits'
import commonActions from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchLowestOrganizedUnitsSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'

export function * fetchLowestOrganizedUnits () {
  try {
    yield put(commonActions.showLoader())
    const auth = yield select(getAuth)
    const response = yield call(getLowestOrganizedUnits, auth.token)
    yield put(fetchLowestOrganizedUnitsSuccess(response))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(commonActions.hideLoader())
  }
}

export function * watchFetchLowestOrganizedUnits () {
  yield takeLatest(combosActionTypes.FETCH_LOWEST_ORGANIZED_UNITS, fetchLowestOrganizedUnits)
}
